import { useState } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateSinistre } from "../../../../../../hooks/useHooks";
import { Alert, Input, Modal, Typography } from "antd";

export const ResponsabilityModal = ({ sinistre, visible, onCancel, onSave, loading, setLoading, initialValue }) => {
    const [taux, setTaux] = useState(initialValue || 0);
    const [motif, setMotif] = useState('');

    const navigate = useNavigate();

    const handleResponsabiliteSave = async () => {
        try {
            setLoading(true);
            const updatedSinistre = {
                ...sinistre,
                tauxResponsabilite: parseInt(taux),
            };

            const response = await updateSinistre(updatedSinistre);
            toast.success("Responsabilité mise à jour avec succès !");
            onCancel();
            navigate("/details-sinistre", {
                state: { codeId: response.data.codeId },
            });
        } catch (error) {
            toast.error(
                "Une erreur est survenue lors de la mise à jour de la responsabilité."
            );
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Taux de responsabilité"
            open={visible}
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={() => handleResponsabiliteSave()}
            okText="Enregistrer"
            cancelText="Annuler"
        >
            <Alert
                type="warning"
                showIcon
                message="Assurez-vous d’avoir lu le PV ou le rapport d’accident."
                style={{ marginBottom: 16 }}
            />
            <div style={{ marginBottom: 16 }}>
                <Typography.Text strong>Définir le taux de responsabilité (%)</Typography.Text>
                <Input
                    type="number"
                    min={0}
                    max={100}
                    value={taux || sinistre?.tauxResponsabilite}
                    defaultValue={sinistre?.tauxResponsabilite}
                    onChange={(e) => setTaux(e.target.value)}
                    style={{ marginTop: 8 }}
                    placeholder="Entre 0 et 100"
                />
            </div>

            <div>
                <Typography.Text strong>Motif de mise à jour *</Typography.Text>
                <Input.TextArea
                    placeholder="Veuillez fournir le motif de mise à jour du taux de responsabilité..."
                    rows={4}
                    value={motif}
                    onChange={(e) => setMotif(e.target.value)}
                    style={{ marginTop: 8 }}
                />
            </div>
        </Modal>
    );
};

ResponsabilityModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    initialValue: PropTypes.number,
    sinistre: PropTypes.object
};